import React from 'react'
import GatewayType from './GatewayType'
import { FlipCardContainer } from '../components/FlipCard'
import { AdministratorFlipCard } from './usermanagement/Administrator'
import { RoleFlipCard } from './usermanagement/Role'
import { TokenProfileFlipCard } from './tokenprofiles/TokenProfiles'
import { ProxyRuntimeFlipCard } from './services/Proxies'
import { AdMappingFlipCard } from './usermanagement/ActiveDirectoryMapping'
import { AdConfigFlipCard } from './usermanagement/ActiveDirectory'
import { SolrConfigFlipCard } from './settings/SolrConfig'

const Dashboard: GatewayType = () => {
  return (
    <FlipCardContainer>
      <ProxyRuntimeFlipCard />
      <TokenProfileFlipCard />
      <AdministratorFlipCard />
      <RoleFlipCard />
      <AdConfigFlipCard />
      <AdMappingFlipCard />
      <SolrConfigFlipCard />
    </FlipCardContainer>
  )
}

export default Dashboard
